module.exports = __webpack_public_path__ + "static/media/fight-boss-background.0b308d81.mp3";